export default [
  `I look for a way to reduce my cost with physical space`,
  `I have my operation distributed, and I need to create a sense of belonging in the teams`,
  `I have part of the operation distributed and part remote, and I need to manage the rotating spaces of the company's offices`,
  `I need a digital workplace to centralize performance metrics and online behavior of my teams`,
  `I need to optimize communication and integration between areas and teams of my company`,
  `I need to have a scale assessment of how my employees are engaged, on-site and remote`
];